import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initCollectionSearchFilters from '../sections/collection/initCollectionSearchFilters';
import initLoadMorePagination from '../sections/collection/initLoadMorePagination';

ready(() => {
  initCollectionSearchFilters();
  initLoadMorePagination();
});

onShopifySectionLoad(() => {
  initCollectionSearchFilters();
  initLoadMorePagination();
});
